import { Navigate } from 'react-router-dom'
import { isYokosoPointsEnabled } from '../lib/features'

/**
 * #1446 ポイント機能が無効な環境で、チャージ画面に入れないようにする。
 *
 * **本番にポイントは存在しない**（`isYokosoPointsEnabled()` が false で支払いの
 * 導線も消えている）のに、`/charge` は `RequireAuth` だけで到達できた。
 * frontend は mode 無しで create-intent を呼ぶため backend の既定 `mock` に落ち、
 * **お金を払わずに残高が増える**状態だった。
 *
 * これは境界ではなく導線を消すためのもの。**API 側にも同じ判定がある**
 * （`execute_charge` / `/payment/execute` が `APP_ENV=prod` で 404）。
 */
export default function RequirePointsEnabled({ children }: { children: React.ReactNode }) {
  if (!isYokosoPointsEnabled()) {
    return <Navigate to="/wallet" replace />
  }
  return <>{children}</>
}
